import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const ActionService = {
    getActionByFilter: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/${id}/custom`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCustomActionsDetail: async function (params = {}) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/custom/details`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getActionFieldConfiguration: async function (actionId) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/${actionId}/custom/field`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCustomActionOutputs: async function (action_ids, autom_version_id = '') {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/custom/outputs`, { params: { action_ids, autom_version_id } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCustomActionOutputFields: async function (action_id, item_id, autom_version_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/${action_id}/custom/output/fields`,
                { params: { item_id, autom_version_id } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getInputValueOptions: async function (id, app_connector_id, action_inputs) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/${id}/custom/input-value-options`, {
                params: {
                    app_connector_id,
                    action_inputs
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getSysFieldOptions: async function (id, app_connector_id, input_keys, action_inputs) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/${id}/custom/sys-field-options`, {
                params: {
                    app_connector_id,
                    input_keys,
                    action_inputs
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getActionByName: async function (action_name) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/byName`, {
                params: {
                    action_name
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getActionShortDetail: async function (library_name, action_name) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/action/short/detail`, {
                params: {
                    library_name,
                    action_name
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    createAutomByAction: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/action/custom/create-autom`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    resetAutomByAction: async function (data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/action/custom/reset-autom`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    renameCustomAction: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/action/${id}/custom/rename`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteAction: async function (id) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + "/action", { data: { id } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
};

export default ActionService;
